import { Modal } from '../../base/_bootstrap';
import { initCarouselClients } from './_carousel-client.js';

document.addEventListener('DOMContentLoaded', () => {
   const grid = document.querySelector('.clients .grid');
   const modal = document.getElementById('modal-client');
   const carousel = modal.querySelector('.carousel');

   let currentRequest = null;

   async function fetchClienteContent(clienteID) {

      /**
       * Cancela requisição anterior se existir
       */
      if (currentRequest) {
         currentRequest.abort();
      }

      currentRequest = new AbortController();

      /**
       * Estado de carregamento
       */
      carousel.innerHTML = `
      <div class="f-carousel__slide">
         <div class="card loading">
            <p>Carregando...</p>
         </div>
      </div>
   `;

      try {

         const response = await fetch(`/wp-json/wp/v2/cliente/${clienteID}`, {
            signal: currentRequest.signal
         });

         if (!response.ok) {
            throw new Error('Erro ao carregar cliente');
         }

         const data = await response.json();

         let acf = data.acf?.cards;

         if (!acf) {
            carousel.innerHTML = '<p>Conteúdo não encontrado.</p>';
            return;
         }

         /**
          * Se vier objeto (quando ACF esconde layouts)
          */
         if (!Array.isArray(acf) && typeof acf === 'object') {
            acf = Object.values(acf);
         }

         if (!Array.isArray(acf)) {
            carousel.innerHTML = '<p>Conteúdo inválido.</p>';
            return;
         }

         carousel.innerHTML = '';

         function resolveImageUrl(img, size = 'full') {

            if (typeof img === 'string') return img;

            if (typeof img !== 'object' || !img.url) return '';

            return img.sizes?.[size] || img.url;

         }

         acf.forEach(modulo => {

            let html = '';

            switch (modulo.acf_fc_layout) {

               case 'cover':

                  html += `
               <div class="f-carousel__slide">
                  <div class="card cover">
                     <div class="type">${modulo.type || ''}</div>
                     <h2>
                        <span>${modulo.name_1 || ''}</span> 
                        ${modulo.name_2 || ''}
                     </h2>
                     <div class="footer">
                        <div class="address">${modulo.address || ''}</div>
                        <div class="since">
                           Nosso cliente desde: 
                           <strong>${modulo.since || ''}</strong>
                        </div>
                     </div>
                  </div>
               </div>`;
                  break;

               case 'general-data':

                  html += `
               <div class="f-carousel__slide">
                  <div class="card general-data">
                     <h2>${modulo.title || ''}</h2>
                     <ul class="list">`;

                  modulo.list?.forEach(item => {

                     const icon = resolveImageUrl(item.icon, 'carousel_client');

                     html += `
                  <li>
                     <img src="${icon}" alt="">
                     <div class="text">
                        <strong>${item.number || ''}</strong>
                        <p>${item.label || ''}</p>
                     </div>
                  </li>`;
                  });

                  html += `</ul></div></div>`;
                  break;

               case 'certification':

                  html += `
               <div class="f-carousel__slide">
                  <div class="card certification">
                     <h2>${modulo.title || ''}</h2>
                     <ul class="list">`;

                  modulo.list?.forEach(cert => {

                     const icon = resolveImageUrl(cert.icon);

                     html += `
                  <li>
                     <img src="${icon}" alt="">
                     <div class="text">
                        <strong>${cert.title || ''}</strong>
                        <p>${cert.text || ''}</p>
                     </div>
                  </li>`;
                  });

                  html += `</ul></div></div>`;
                  break;

               case 'advantages':

                  html += `
               <div class="f-carousel__slide">
                  <div class="card advantages">
                     <h2>${modulo.title || ''}</h2>
                     <ul class="list">`;

                  modulo.list?.forEach(advantage => {

                     const icon = resolveImageUrl(advantage.icon);

                     html += `
                  <li>
                     <img src="${icon}" alt="">
                     <div class="text">
                        <p>${advantage.title || ''}</p>
                     </div>
                  </li>`;
                  });

                  html += `</ul></div></div>`;
                  break;

               case 'image':

                  const image = resolveImageUrl(modulo.image, 'carousel_photo');

                  html += `
               <div class="f-carousel__slide image">
                  <div class="card image">
                     <img src="${image}" alt="">
                  </div>
               </div>`;
                  break;

               case 'infos':

                  html += `
               <div class="f-carousel__slide">
                  <div class="card infos">
                     <h2>${modulo.title || ''}</h2>`;

                  if (modulo.grid?.length) {

                     html += `<ul class="grid">`;

                     modulo.grid.forEach(info => {

                        html += `
                     <li>
                        <strong>${info.topic || ''}</strong>
                        <p>${info.text || ''}</p>
                     </li>`;
                     });

                     html += `</ul>`;
                  }

                  if (modulo.list?.length) {

                     html += `<ul class="list">`;

                     modulo.list.forEach(info => {

                        html += `
                     <li>
                        <strong>${info.topic || ''}</strong>
                        <p>${info.text || ''}</p>
                     </li>`;
                     });

                     html += `</ul>`;
                  }

                  html += `</div></div>`;
                  break;
            }

            carousel.insertAdjacentHTML('beforeend', html);

         });

         /**
          * Inicializa carousel após renderizar
          */
         initCarouselClients();

      }
      catch (error) {

         if (error.name === 'AbortError') return;

         console.error(error);

         carousel.innerHTML = `
         <div class="f-carousel__slide">
            <div class="card error">
               <p>Erro ao carregar conteúdo.</p>
            </div>
         </div>
      `;

      }

   }


   grid.addEventListener('click', e => {
      const item = e.target.closest('.item');
      if (!item || !grid.contains(item)) return;

      e.preventDefault();

      const clienteID = item.dataset.id;
      if (!clienteID) return;

      /**
       * Limpa conteúdo antigo imediatamente
       */
      carousel.innerHTML = `
      <div class="loading">
         <p>Carregando...</p>
      </div>
   `;

      new Modal(modal).show();

      fetchClienteContent(clienteID);
   });
});
